<template>
    <footer class="border-top footer text-muted bg-main">
        <div class="container">
            &copy; 2023 - СД
        </div>
    </footer>
    <div id="toasts" style="position: fixed; top: 5%; right: 0; left: 80%; z-index: 10000;"></div>
</template>